// extracted by mini-css-extract-plugin
module.exports =  {"propertyDamage":"CollisionDetailsPage_propertyDamage__UtVpP"};